import React from 'react';
import { Keyboard } from 'lucide-react';
import { TOOL_SHORTCUTS } from './constants';

const KeyboardShortcuts = ({ isOpen, onClose, darkMode }) => {
    if (!isOpen) return null;

    const shortcuts = [
        { key: 'V / S', action: 'Seleccionar' },
        { key: 'P', action: 'Lápiz' },
        { key: 'L', action: 'Línea' },
        { key: 'C', action: 'Curva' },
        { key: 'R', action: 'Rectángulo' },
        { key: 'O', action: 'Círculo' },
        { key: 'T', action: 'Triángulo' },
        { key: 'B', action: 'Relleno' },
        { key: 'E', action: 'Borrador' },
        { key: 'Espacio', action: 'Mover canvas' },
        { key: 'Ctrl+Z', action: 'Deshacer' },
        { key: 'Ctrl+Y', action: 'Rehacer' },
        { key: 'Ctrl+S', action: 'Guardar PNG' },
        { key: 'Supr / Backspace', action: 'Borrar selección' },
        { key: '+/-', action: 'Zoom' },
        { key: 'Scroll', action: 'Zoom con ratón' },
    ];

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm" onClick={onClose}>
            <div
                className={`
                    w-full max-w-sm mx-4 p-6 rounded-3xl shadow-2xl
                    ${darkMode
                        ? 'bg-gray-800 border border-white/10'
                        : 'bg-white border border-gray-200'
                    }
                `}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="flex items-center justify-center gap-3 mb-6">
                    <Keyboard size={24} className={darkMode ? 'text-violet-400' : 'text-blue-500'} />
                    <h3 className={`text-lg font-bold ${darkMode ? 'text-white' : 'text-gray-800'}`}>
                        Atajos de Teclado
                    </h3>
                </div>

                <div className="space-y-2 max-h-80 overflow-y-auto">
                    {shortcuts.map(({ key, action }) => (
                        <div
                            key={key}
                            className={`
                                flex items-center justify-between py-2 px-3 rounded-xl
                                ${darkMode ? 'bg-white/5' : 'bg-gray-50'}
                            `}
                        >
                            <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
                                {action}
                            </span>
                            <kbd className={`
                                px-2 py-1 rounded-lg text-xs font-mono font-bold
                                ${darkMode
                                    ? 'bg-gray-700 text-gray-300 border border-gray-600'
                                    : 'bg-gray-200 text-gray-700 border border-gray-300'
                                }
                            `}>
                                {key}
                            </kbd>
                        </div>
                    ))}
                </div>

                <button
                    onClick={onClose}
                    className={`
                        w-full mt-6 py-3 rounded-2xl font-semibold transition-all duration-200
                        ${darkMode
                            ? 'bg-violet-600 text-white hover:bg-violet-500'
                            : 'bg-blue-500 text-white hover:bg-blue-600'
                        }
                    `}
                >
                    Cerrar
                </button>
            </div>
        </div>
    );
};

export default KeyboardShortcuts;
